<template>
  <div class="curie-temp-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>T > Tc → 铁磁性消失$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- The Magnet -->
          <rect x="50" y="100" width="100" height="40" :fill="magnetColor" stroke="#888" />
          <text x="60" y="125" fill="#fff" font-size="20" font-weight="bold">N</text>
          <text x="120" y="125" fill="#fff" font-size="20" font-weight="bold">S</text>

          <!-- Magnetic Field Lines -->
          <g v-if="isMagnetic">
             <path v-for="i in 3" :key="'f'+i" :d="calcField(i)" fill="none" stroke="rgba(255, 71, 87, 0.4)" stroke-dasharray="2" />
          </g>

          <!-- Iron Nails (Attracted) -->
          <g :transform="`translate(${isMagnetic ? 180 : 300}, 120)`">
             <rect x="0" y="-2" width="20" height="4" fill="#aaa" rx="1" />
             <rect x="5" y="5" width="20" height="4" fill="#aaa" rx="1" />
          </g>

          <!-- Heat Source -->
          <g transform="translate(100, 180)">
             <path d="M -20,0 Q -10,-20 0,0 Q 10,20 20,0" fill="none" stroke="#ff4757" opacity="0.6">
                <animate attributeName="stroke-dashoffset" from="100" to="0" dur="1s" repeatCount="indefinite" />
             </path>
             <text x="-15" y="20" fill="#ff4757" font-size="8">加热源</text>
          </g>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>当前温度 T: {{ temp }} °C</label>
              <div class="value" :style="{ color: isMagnetic ? '#ff4757' : '#888' }">{{ isMagnetic ? '铁磁态' : '顺磁态 (失去磁性)' }}</div>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row items-center">
             <label>调节温度 T (镍 Tc ≈ 358°C)</label>
             <el-slider v-model="temp" :min="20" :max="600" size="mini"></el-slider>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>铁磁物质在温度升高时，内部分子的热运动会破坏磁畴的规则排列。当温度达到**居里点**（Curie Point）时，磁畴彻底混乱，物质从强磁性的铁磁态转变为弱磁性的**顺磁态**。这是一个典型的二级相变过程。当温度降回临界点以下，磁性通常会自发恢复。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CurieTemperatureViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      temp: 20,
      curie: 358
    }
  },
  computed: {
    isMagnetic() { return this.temp < this.curie; },
    magnetColor() {
       let heat = Math.min(1, (this.temp - 20) / 600);
       return `rgb(${80 + heat*150}, ${80 - heat*40}, ${80 - heat*40})`;
    }
  },
  methods: {
    calcField(i) {
       let h = i * 40;
       return `M 150 120 Q ${150 + h} ${120 - h} 100 ${120 - h} Q 50 ${120 - h} 50 120`;
    }
  }
}
</script>

<style scoped lang="scss">
.curie-temp-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(255, 71, 87, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
